export const marginArray = [{ name: "1000" }, { name: "2000" }, { name: "5000" }, { name: "10000" }, { name: "20000" }, { name: "50000" }, { name: "100000" }];

export const maxMargin = [{ label: "مبلغ", value: "price" }, { label: "درصد", value: "percent" }, {
    label: "قیمت نهایی",
    value: "maxPrice"
}];

export const variantByBox = [{ label: "محصول", value: "productBox" }, { label: "تنوع", value: "variantBox" }]

export const minMargin = [{ label: "مبلغ", value: "price" }, { label: "درصد", value: "percent" }, {
    label: "قیمت نهایی",
    value: "minPrice"
}];
export const priceIncrease = [
    { label: "آزاد (بیشترین قیمت ممکن)", value: "free" }, {
        label: "محدود به قیمت مرجع",
        value: 'referencePrice'
    }, { label: "محدود به حداکثر سود", value: 'maximumProfit' }];
export const competitionType = [{ label: "ثابت", value: "fix" }];
export const salesType = [{ label: "فروش عادی", value: "normal" }];
export const reactive = [{ label: "غیرفعال", value: "disable" }, { label: "فعال", value: "enable" }];
export const safePricing = [{ label: "فعال", value: "enable" }, { label: "غیرفعال", value: "disable" }];
export const hasMaxPriceLimit = [{ label: "فعال", value: true }, { label: "غیرفعال", value: false }];
export const strategyTitle = {
    outOfRangeStrategy: 'درصورتی که قیمت فروش فعلی محصول شما در بازه قیمتی بین حداقل و حداکثر تعیین شده توسط شما نباشد،',
    hasIncreasePricePermission: {
        aiSmart: 'اگر قیمتی که شما برای تصاحب باکس نیاز دارید پایین‌تر از حداقل قیمت تعیین شده شما باشد، ',
        lowestPrice: 'اگر قیمتی که شما برای داشتن پایین‌ترین قیمت بین رقبا نیاز دارید، پایین‌تر از حداقل قیمت تعیین شده شما باشد. ',
        equalToBoxWinner: 'اگر شما برای داشتن قیمت یکسان با برنده باکس،‌نیاز به قیمتی کمتر از حداقل قیمت تعیین شده خودتان داشته باشید. ربات قیمت فعلی شما کالای شما را....',
        boxMoment: 'اگر قیمتی که شما برای تصاحب باکس نیاز دارید پایین‌تر از حداقل قیمت تعیین شده شما باشد، ',
        boxStep: 'اگر قیمتی که شما برای تصاحب باکس نیاز دارید پایین‌تر از حداقل قیمت تعیین شده شما باشد، '
    }
}
export const outOfRangeStrategy = [{ label: "قیمت را تغییر ندهد", value: "off" }, { label: "به حداقل قیمتی که تعیین کرده‌اید کاهش دهد", value: "minPrice" }, { label: "تنوع را در دیجی کالا غیرفعال کند", value: "deactiveProduct" }]
export const hasIncreasePricePermission = [{ label: "قیمت را تغییر ندهد", value: "off" }, { label: "به حداکثر قیمتی که تعیین کرده‌اید افزایش دهد", value: "maxPrice" }, { label: "به حداقل قیمتی که تعیین کرده‌اید کاهش دهد", value: "minPrice" }]
export const strategy = [
    { label: "موجود در باکس (لحظه‌ای)", value: "boxMoment" },
    { label: "قیمت یکسان با برنده باکس", value: 'equalToBoxWinner' },
    { label: "کمترین قیمت", value: "lowestPrice" },
    { label: "موجود در باکس (پلکانی)", value: 'boxStep' },
    { label: "باکس هوشمند", value: 'aiSmart' },
];
export const promotion = [{ label: "بدون تغییر قیمت", value: 'false' }, {
    label: "فعال‌سازی ربات در تخفیف هوشمند",
    value: 'true'
}]
export const serverDataFields = [
    { tag: "purchasePrice", error: "!قیمت خرید را وارد کنید" },
    { tag: "minimumProfitMargin", error: '!حداقل حاشیه سود را وارد کنید' }, {
        tag: "minimumProfitMarginType",
        error: '!حداقل حاشیه سود را وارد کنید'
    },
    { tag: "maximumProfitMargin", error: '!حداکثر حاشیه سود را وارد کنید' }, {
        tag: "maximumProfitMarginType",
        error: '!حداکثر حاشیه سود را وارد کنید'
    },
    { tag: "sizeOfPriceIncrease", error: '!پله تغییر قیمت را وارد کنید' }, {
        tag: "pricingStrategy",
        error: '!نوع استراتژی را وارد کنید'
    },
    { tag: "priceIncrease", error: '!نوع افزایش قیمت را وارد کنید' },
    // {
    //     tag: "competitionType",
    //     error: '!نوع رقابت را وارد کنید'
    // },
    // { tag: "sellingType", error: '!نوع فروش را وارد کنید' },
    {
        tag: "reactivation",
        error: '!نوع فعال‌سازی مجدد را وارد کنید'
    }];